<template>
  <div class="summary">
    <h2>SUMMARY</h2>

    <v-row class="summary__row">
      <v-col class="col-4">
        <h4 class="summary__title">Primary Information</h4>
      </v-col>
      <v-col>
        <span class="summary__item">
          {{ developer.personal_data.first_name }} {{ developer.personal_data.last_name }}
        </span>
        <span>{{ developer.roles.join(', ') }}</span>
        <span class="summary__item">{{ developer.personal_data.level }}</span>
        <span v-if="developer.personal_data.experience_in_years" class="summary__item">
          {{ developer.personal_data.experience_in_years }} years experience
        </span>
        <span v-if="developer.personal_data.city" class="summary__item">
          {{ developer.personal_data.city }}, {{ developer.personal_data.nationality }}
        </span>
      </v-col>
    </v-row>

    <v-row class="summary__row">
      <v-col class="col-4">
        <h4 class="summary__title">Finance</h4>
      </v-col>
      <v-col>
        <span
          v-if="developer.finance.rate"
          class="summary__item">
            {{ developer.finance.rate }} PLN per hour
        </span>
        <span class="summary__item">{{ developer.finance.working_hours.join(', ') }}</span>
        <span class="summary__item">{{ developer.finance.contract_types.join(', ') }}</span>
      </v-col>
    </v-row>

    <v-row v-if="objectIsEmpty" class="summary__row">
      <v-col class="col-4">
        <h4 class="summary__title">Model of personality <br> structure</h4>
        <p class="summary__content">
          It is a Polish adaptation of the "Ten-Item Personality Inventory" test.
          (TIPI) (Gosling, Rentfrow, Swann Jr., 2003). It takes two minutes to complete,
          and it is a relatively accurate and reliable tool for measuring
          personality in scientific research. The authors of the Polish adaptation
          of the test are: Agnieszka Sorokowska, Aleksandra Słowińska,
          Anita Zbieg and Piotr Sorokowski (2014).

        </p>
      </v-col>
      <v-col class="col-8 summary__wrapper">
        <ChartRadar :chart-data="datacollection" class="summary__chart-radar"/>
        <div class="summary__description">
          <div v-for="(value, name, index) in this.developer.soft_skills" :key="index">

            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <span class="summary__skill-name">
                  {{ index+1 }}. {{ name }}
                </span>
                <span v-bind="attrs" v-on="on" class="summary__value">
                  {{ Math.ceil(value/7*100) }}%
                </span>
              </template>
              <div class="summary__tooltip" v-html="skillsDescriptions[name]">
              </div>
            </v-tooltip>

          </div>
        </div>
      </v-col>
    </v-row>

    <v-row class="summary__row">
      <v-col class="col-4">
        <h4 class="summary__title">Skills</h4>
      </v-col>
      <v-col>
        <div v-for="(featureGroup, index) in featureGroups" :key="index">
          <span class="summary__skill-list">{{ featureGroup.name }}</span>
          <FeaturesList
            v-if="featureGroup.data && featureGroup.data.length"
            :features="developer.roles"
            :editable="false"
            :primary="true"
        />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import skillsDescriptions from '@/helpers/skillsDescriptions';
import ChartRadar from '@/components/Developers/Show/ChartRadar.vue';
import FeaturesList from '@/components/Developers/Show/FeaturesList.vue';

export default {
  components: {
    ChartRadar,
    FeaturesList,
  },

  data() {
    return {
      skillsDescriptions,
    };
  },

  computed: {
    ...mapState('developer', ['developer']),

    featureGroups() {
      return [
        {
          name: 'Primary Roles',
          data: this.developer.roles,
        },
        {
          name: 'Top Skills',
          data: this.developer.top_skills,
        },
        {
          name: 'Languages',
          data: this.developer.languages,
        },
      ];
    },

    datacollection() {
      const chartData = {
        labels: [
          '1',
          '2',
          '3',
          '4',
          '5',
        ],
        datasets: [
          {
            label: 'Score',
            backgroundColor: 'rgba(108, 123, 230, 1)',
            fill: true,
            data: this.developer.soft_skills ? Object.values(this.developer.soft_skills) : [],
          },
        ],
      };

      return chartData;
    },

    objectIsEmpty() {
      return (Object.keys(this.developer.soft_skills).length !== 0);
    },
  },
};

</script>

<style lang="scss" scope>
.summary {
  font-size: 14px;
    &__row {
      margin-top: 32px;
    }

    &__item {
      display: block;
    }

    &__content {
      font-size: 12px;
      line-height: 18px;
      opacity: 0.7;
      max-width: 223px;
    }

    &__wrapper {
        display: flex;
    }

    &__chart-radar {
      width: 180px;
      margin-right: 75px;
    }

    &__description {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    &__skill-name {
      min-width: 140px;
      font-weight: bold;
      font-size: 12px;
      text-transform: capitalize;
      display: block;
    }

    &__skill-list {
      margin: 8px 0 4px;
      display: block;
    }

    &__value {
      font-size: 14px;
      color: $color--blue;
      font-weight: 500;
    }
    &__tooltip {
      max-width: 550px;
      padding: 10px;
    }
}
</style>
